const firebaseConfig = {
    apiKey: "AIzaSyBBPR8saTQXl_dPoW_1N2jfl1MvdQGXMiU",
    authDomain: "luxury-car-e3533.firebaseapp.com",
    projectId: "luxury-car-e3533",
    storageBucket: "luxury-car-e3533.appspot.com",
    messagingSenderId: "1045882169359",
    appId: "1:1045882169359:web:ea6be236b84c1207a91b7a"
  };

  export default firebaseConfig;   